export class OidcConfiguration {
  public static accessTokenExpiringNotificationTime = 60;
  public static automaticSilentRenew = false;
  public static response_type = "id_token token";
  public static scope = "openid";
  /**
   * PrÃ©fixe pour stocker tous les objets dans
   */
  public static storagePrefix = "bnpp.oidc";

  /**
   * Suffixe pour stocker l'ID token
   */
  public static storageIdtPostfix = ".id_token";

  /**
   * Suffixe pour stocker l'access token
   */
  public static storageAtPostfix = ".access_token";

  /**
   * Suffixe pour stocker le nonce
   */
  public static storageNoncePostfix = ".nonce";

  public static storageStatePostfix =".state";

  public static userStore = localStorage;

  /**
   * Personalisabler
   */
  public static client_id = "HanieApplicationAngular";
}
